// find drawer cart element
const drawerCartElement = document.getElementById("drawer-cart");

// attach event listener to the relevant buttons
drawerCartElement.addEventListener("click", async (e) => {
  try {
    const bundleUpgradeButton = e.target.closest(
      `[data-upsell-bundle-action="upsell-bundle-upgrade"], [data-upsell-bundle-action="upsell-bundle-upgrade-undo"]`
    );
    if (bundleUpgradeButton) {
      // disable button
      bundleUpgradeButton.disabled = true;

      // hide button text
      bundleUpgradeButton.querySelector('.upsell-bundle-upgrade-button-text').innerHTML = '&nbsp';

      // show loader
      bundleUpgradeButton.querySelector('.loading-overlay').classList.remove('hidden');

      // Get current line item using variant ID based on action
      const isUpgrade = bundleUpgradeButton.dataset.upsellBundleAction === 'upsell-bundle-upgrade';
      const relatedVariantId = isUpgrade 
        ? bundleUpgradeButton.dataset.upsellBundleRelatedVariant 
        : bundleUpgradeButton.dataset.upsellBundleVariant;
      const currentLineItem = document.querySelector(`[data-key*="${relatedVariantId}"]`);
      const lineIndex = parseInt(currentLineItem?.dataset.index);
      
      let currentSellingPlanId = bundleUpgradeButton.dataset.variantSellingPlanId;
      
      // Fetch current cart to get selling plan name
      if (lineIndex) {
        try {
          const cartResponse = await fetch('/cart.js');
          const cartData = await cartResponse.json();
          const cartItem = cartData.items[lineIndex - 1];
          const currentSellingPlanName = cartItem?.selling_plan_allocation?.selling_plan?.name;
          
          if (currentSellingPlanName) {
            // Parse selling plan map from button data attribute
            const sellingPlanMap = bundleUpgradeButton.dataset.sellingPlanMap;
            if (sellingPlanMap) {
              const plans = sellingPlanMap.split('|');
              for (const plan of plans) {
                const [name, id] = plan.split(':');
                if (name === currentSellingPlanName) {
                  currentSellingPlanId = id;
                  break;
                }
              }
            }
          }
        } catch (error) {
          console.error('Failed to fetch selling plan:', error);
        }
      }

      // init event
      const event = new CustomEvent("estrid:swap-upsell-bundle-upgrade", {
        detail: {
          upsellBundleAction: bundleUpgradeButton.dataset.upsellBundleAction,
          upsellBundleRelatedVariant: bundleUpgradeButton.dataset.upsellBundleRelatedVariant,
          upsellBundleVariant: bundleUpgradeButton.dataset.upsellBundleVariant,
          variantSellingPlanId: currentSellingPlanId
        }
      });

      // trigger event
      document.dispatchEvent(event);
    }
  } catch (error) {
    console.error("Error handling upsell bundle upgrade click:", error);
  }
});
